import { FC, ReactNode } from "react";

import { Column, Text, Spinner } from "@hightouch/htui";

import { Link } from "src/router";

import { DbtSyncModelQuery, useDbtSyncModelQuery } from "src/graphql";
import { DBTIcon } from "src/ui/icons";
import { Strike } from "src/utils/strike";
import {
  QueryContainer,
  QueryHeader,
  QueryHeaderTitle,
  QueryContent,
} from "src/components/query";

type Props = {
  id?: number | null;
  model?: DbtSyncModelQuery["dbt_sync_models_by_pk"];
  oldModel?: DbtSyncModelQuery["dbt_sync_models_by_pk"];
  actions?: ReactNode;
};

export const DbtQuery: FC<Readonly<Props>> = ({
  id,
  model: propsModel,
  oldModel,
  actions,
}) => {
  const { data, isLoading } = useDbtSyncModelQuery(
    {
      id: String(id),
    },
    { enabled: Boolean(id), select: (data) => data.dbt_sync_models_by_pk },
  );

  const model = data ?? propsModel;

  const getName = (model) => model?.data?.alias || model?.name;

  return (
    <QueryContainer>
      <QueryHeader>
        <QueryHeaderTitle icon={<DBTIcon />} title="dbt model" />
        {actions}
      </QueryHeader>
      <QueryContent>
        {isLoading ? (
          <Spinner size="lg" m="auto" />
        ) : (
          <>
            <Column>
              <Text fontWeight="medium">Name</Text>
              <Strike _new={getName(model)} old={getName(oldModel)} />
            </Column>
            <Column>
              <Text fontWeight="medium">dbt Unique ID</Text>
              <Strike
                _new={model?.dbt_unique_id}
                old={oldModel?.dbt_unique_id}
              />
            </Column>
            {model?.data?.description && (
              <Column>
                <Text fontWeight="medium">Description</Text>
                <Strike
                  _new={model?.data?.description}
                  old={oldModel?.data?.description}
                />
              </Column>
            )}
            {model?.dbt_sync_config?.repository && (
              <Column>
                <Text fontWeight="medium">Repository</Text>
                <Link href={model?.dbt_sync_config?.repository}>
                  {model?.dbt_sync_config?.repository}
                </Link>
              </Column>
            )}
            {model?.dbt_cloud_sync_config && (
              <Column>
                <Text fontWeight="medium">Cloud Job</Text>
                <Text>{model?.dbt_cloud_sync_config.job_id}</Text>
                <Text fontWeight="medium">Last Run</Text>
                <Text>{model?.dbt_cloud_sync_config.last_run_at}</Text>
              </Column>
            )}
          </>
        )}
      </QueryContent>
    </QueryContainer>
  );
};
